import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, BadgeCheck, Building2, Search } from 'lucide-react';
import { PageHeader } from '../components/page/PageHeader';
import { CtaBand } from '../components/page/CtaBand';
import { Reveal } from '../components/ui/Reveal';
import { Badge } from '../components/ui/Badge';
import { CASE_STUDIES } from '../components/caseStudiesData';
export const CaseStudies = () => {
  return <>
      <PageHeader eyebrow="Case Studies" title="Teams moving from discovery to activation" subtitle="How brands and marketing agencies use Zano to source and manage talent agency relationships at scale." data-id="element-2003" data-mp="36yjaw2jp5z3r" />

      <section aria-labelledby="positioning-banner-title" className="mx-auto max-w-[1584px] px-4 pb-10 sm:px-6 lg:px-8" data-id="element-2004" data-mp="31ywszfsxbuom">
        <Reveal data-id="element-2005" data-mp="1mhd7frp4iwdq">
          <div className="relative overflow-hidden rounded-3xl bg-zano-charcoal px-6 py-8 sm:px-10 sm:py-10 xl:aspect-[4/1] xl:px-14 xl:py-7" data-id="element-2006" data-mp="1mgv1228qz1s3">
            <div className="pointer-events-none absolute right-0 top-0 h-32 w-32 -translate-y-1/2 translate-x-1/3 rounded-full border-[22px] border-zano-pink/20" data-id="element-2007" data-mp="8e18wd5cd5s3" />
            <div className="pointer-events-none absolute bottom-0 left-0 h-44 w-44 -translate-x-1/2 translate-y-1/2 rounded-full border-[18px] border-white/5" data-id="element-2008" data-mp="3hawq0wnquby" />
            <div className="pointer-events-none absolute bottom-0 left-[30%] hidden h-[58%] w-px bg-white/10 xl:block" data-id="element-2009" data-mp="dcb58r2sycfa" />

            <div className="relative grid h-full items-center gap-7 xl:grid-cols-[480px_minmax(0,1fr)_minmax(390px,0.82fr)] xl:gap-7" data-id="element-2010" data-mp="rbkndwakjglw">
              <div className="hidden self-stretch xl:block" aria-hidden="true" data-id="element-2011" data-mp="112yrkhdgt4ld" />

              <div className="xl:pl-1" data-id="element-2012" data-mp="w3ltt1l22d40">
                <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-zano-pink" data-id="element-2013" data-mp="w4nhc5j9cs2m">
                  Your agency partner network
                </p>
                <h2 id="positioning-banner-title" className="max-w-[28rem] text-3xl font-bold leading-[1.08] text-white sm:text-4xl" data-id="element-2014" data-mp="155lga9eua9ec">
                  Keep partner rosters current.{' '}
                  <span className="text-zano-pink" data-id="element-2015" data-mp="7nuppsq2qg36">
                    Discover new agencies at scale.
                  </span>
                </h2>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-gray-300 sm:text-base" data-id="element-2016" data-mp="gjkiimtuqcql">
                  Stay up to date with the live rosters of agencies you already
                  work with, then discover vetted new talent agency partners in
                  the same place.
                </p>
                <div className="mt-4 flex flex-wrap gap-x-4 gap-y-2 text-xs text-gray-300" data-id="element-2017" data-mp="vh4jlinmnnrh">
                  <span className="inline-flex items-center gap-1.5" data-id="element-2018" data-mp="zgdcklaufhlz">
                    <BadgeCheck size={15} className="text-zano-pink" data-id="element-2019" data-mp="2x7g0z3re7gox" />
                    Live partner rosters
                  </span>
                  <span className="inline-flex items-center gap-1.5" data-id="element-2020" data-mp="319jd7ulvypb9">
                    <Building2 size={15} className="text-zano-pink" data-id="element-2021" data-mp="2tpsapdm0ksii" />
                    400+ vetted agencies
                  </span>
                </div>
              </div>

              <div className="rounded-2xl border border-white/10 bg-white p-3 text-left shadow-2xl" aria-label="Example of a live agency roster search" data-id="element-2022" data-mp="2jzfg0skhjiyn">
                <div className="mb-2 flex items-center gap-2 border-b border-gray-100 pb-2" data-id="element-2023" data-mp="3co4gqqhmpm9v">
                  <div className="flex gap-1" data-id="element-2024" data-mp="37p0bgaxts8ot">
                    <span className="h-2 w-2 rounded-full bg-rose-300" data-id="element-2025" data-mp="37qbeg8jg5cev" />
                    <span className="h-2 w-2 rounded-full bg-amber-300" data-id="element-2026" data-mp="33mww3b81cjy9" />
                    <span className="h-2 w-2 rounded-full bg-emerald-300" data-id="element-2027" data-mp="33p9a5daoaa61" />
                  </div>
                  <span className="ml-1 text-[11px] font-semibold text-gray-500" data-id="element-2028" data-mp="2yqoe7q2gecne">
                    Live Roster Database
                  </span>
                  <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[9px] font-semibold text-emerald-700" data-id="element-2029" data-mp="1n856t766rst6">
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" data-id="element-2030" data-mp="3fwkxawknudx8" />
                    Updated live
                  </span>
                </div>

                <div className="flex items-center gap-2 rounded-lg border border-zano-pink/30 bg-zano-blush/50 px-3 py-1.5" data-id="element-2031" data-mp="326r9mhkw5zp3">
                  <Search size={15} className="shrink-0 text-zano-pink" data-id="element-2032" data-mp="364f4xlqhxuhi" />
                  <span className="truncate text-xs font-medium text-gray-700" data-id="element-2033" data-mp="3twvsgbt06eo7">
                    Search represented creators
                  </span>
                  <span className="ml-auto hidden rounded-md bg-white px-2 py-1 text-[10px] font-medium text-gray-500 sm:inline" data-id="element-2034" data-mp="3kw79r3snzq4z">
                    Filters
                  </span>
                </div>

                <div className="mt-2 space-y-1.5" data-id="element-2035" data-mp="29fzdfk3ttb1r">
                  {[{
                  name: 'Clicks Talent',
                  logo: 'https://cdn.magicpatterns.com/uploads/oKbracun8P5MXQXuDPFXrA/clicks_talent_logo.webp'
                }, {
                  name: 'United Talent Agency',
                  logo: 'https://cdn.magicpatterns.com/uploads/iMEkKfrRdejvDfRHdG5tcE/uta.png'
                }, {
                  name: 'Famfluence',
                  logo: 'https://cdn.magicpatterns.com/uploads/iq5ZMVZ2aiG8SYPyU7XxgR/famfluence_logo.png'
                }].map(agency => <div key={agency.name} className="flex min-w-0 items-center gap-3 rounded-xl border border-gray-100 px-3 py-1.5" data-id="element-2036" data-mp="1ia1woeqahaxv">
                      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-gray-100 bg-white p-1" data-id="element-2037" data-mp="1s658kcay0ny0">
                        <img src={agency.logo} alt={`${agency.name} logo`} className="h-full w-full object-contain" data-id="element-2038" data-mp="14fj0il0xv3o0" />
                      </div>
                      <span className="truncate text-xs font-semibold text-gray-800" data-id="element-2039" data-mp="34j23wkjs7q79">
                        {agency.name}
                      </span>
                      <BadgeCheck size={14} className="ml-auto shrink-0 text-emerald-500" data-id="element-2040" data-mp="39cog6bm19s2j" />
                    </div>)}
                </div>

                <p className="mt-2 text-center text-[10px] leading-relaxed text-gray-500" data-id="element-2041" data-mp="2lkpqgmlu7u5v">
                  Agency-owned data, not scraped creator profiles.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </section>

      {/* Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pb-16" data-id="element-2042" data-mp="2ujba6l31pf88">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2043" data-mp="4w3r2uz9s2dv">
          {CASE_STUDIES.map((c, i) => <Reveal key={c.slug} delay={i % 2 * 0.1} data-id="element-2044" data-mp="9xjf8vwqup0h" data-mpi={i}>
              <Link to={`/case-studies/${c.slug}`} className="group flex flex-col h-full bg-white rounded-3xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-float hover:-translate-y-1 transition-all duration-300" data-id="element-2045" data-mp="jyc16p0v9hp1">
                <div className={`h-40 w-full flex items-center justify-center p-8 ${c.logoBg}`} data-id="element-2046" data-mp="68iae15swnco">
                  <img src={c.logo} alt={`${c.brand} logo`} className="max-h-full max-w-[180px] object-contain transition-transform duration-500 group-hover:scale-105" data-id="element-2047" data-mp="19ovc4av8oae" />
                </div>
                <div className="p-8 flex flex-col flex-1" data-id="element-2048" data-mp="3jf0gfps94lq8">
                  <div className="flex flex-wrap gap-2 mb-4" data-id="element-2049" data-mp="3jglgfuxc4wvh">
                    {c.tags.map(tag => <Badge key={tag} className="bg-blue-50 border border-blue-200 text-blue-700" data-id="element-2050" data-mp="1lmeevplcerpq">
                        {tag}
                      </Badge>)}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 leading-snug group-hover:text-zano-pink transition-colors" data-id="element-2051" data-mp="24wpd3js5fnqn">
                    {c.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-2052" data-mp="1w3vtja5o626z">
                    {c.subtitle}
                  </p>
                  <div className="flex items-center text-sm font-bold text-zano-pink mt-auto" data-id="element-2053" data-mp="1ha946ew56gfy">
                    Read Case Study
                    <ArrowUpRight size={16} className="ml-1 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-2054" data-mp="187zvlukfox57" />
                  </div>
                </div>
              </Link>
            </Reveal>)}
        </div>
      </section>

      <CtaBand title="Be the next team to ditch the spreadsheets" subtitle="Start a free trial today and access the elite layer of talent representation." primaryCta={{
      label: 'Start Free Trial',
      to: '/pricing'
    }} data-id="element-2055" data-mp="37jtxizlzpy1c" />
    </>;
};